import { useRouter } from 'next/router';
import type { FC, ReactNode } from 'react';
import { Button } from '@/DesignSystem/Component';
import { IconAngleRight } from '@/Module/Icon';
interface ILessonListHeaderProps {
  title: ReactNode;
}
const LessonListHeader: FC<ILessonListHeaderProps> = ({
  title
}) => {
  const router = useRouter();
  const onBackClick = () => {
    router.back();
  };
  return <div className="mb-9 flex items-stretch gap-2 lg:mb-12" data-sentry-component="LessonListHeader" data-sentry-source-file="LessonListHeader.tsx">
      <div className="flex items-center">
        <Button variant="text" color="orangeDark" onClick={onBackClick} iconButton data-sentry-element="Button" data-sentry-source-file="LessonListHeader.tsx">
          <IconAngleRight data-sentry-element="IconAngleRight" data-sentry-source-file="LessonListHeader.tsx" />
        </Button>
      </div>
      <div className="flex flex-col items-start gap-2 lg:gap-4 ">
        <h1 className="text-2xl font-bold lg:text-4xl">{title}</h1>
        <h2 className="text-xl lg:text-3xl">با آی‌نو سخت نگیر؛ یاد بگیر:</h2>
      </div>
    </div>;
};
export default LessonListHeader;